import { types } from './actions';

export const CORPORATE_ADMIN = 'corporate_admin';

const initialState = {
  user: null,
  credentials: null,
  isLoading: false,
  errorMessage: null,
  isAuthenticated: false,
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER: {
      const { user } = action;
      return {
        ...state,
        user,
      };
    }
    case types.CLEAR_USER: {
      const user = null;
      return {
        ...state,
        user,
      };
    }
    case types.SET_CREDENTIALS: {
      const { credentials } = action;
      return {
        ...state,
        credentials,
      };
    }
    case types.CLEAR_CREDENTIALS: {
      const credentials = null;
      return {
        ...state,
        credentials,
      };
    }
    case types.LOGIN_REQUEST: {
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    }
    case types.LOGIN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errorMessage: null,
        isAuthenticated: true,
      };
    }
    case types.LOGIN_FAILURE: {
      const { errorMessage } = action;
      return {
        ...state,
        isLoading: false,
        errorMessage,
      };
    }
    case types.LOGIN_CLEAR: {
      const isLoading = false;
      const errorMessage = null;
      return {
        ...state,
        isLoading,
        errorMessage,
        isAuthenticated: false,
      };
    }
    default:
      return state;
  }
};


export default reducer;
